import { components } from '@/generated-types/oneroster-openapi';

export type SubjectEnum = components['schemas']['SubjectEnum'];
export const SubjectEnumValues = [
  'Reading',
  'Language',
  'Vocabulary',
  'Social Studies',
  'Writing',
  'Science',
  'FastMath',
  'Math',
] as const satisfies SubjectEnum[];

export const EnabledSubjectsValues = [
  'Language',
  'Reading',
  'Math',
  'Science',
  'Writing',
  // Commented out while Beyond.AI fixes these tests and we include their Resources
  // 'Social Studies',
] as const satisfies SubjectEnum[];

export type EnabledSubjects = (typeof EnabledSubjectsValues)[number];

export type GradeEnum = components['schemas']['GradeEnum'];
export const GradeEnumValues = [
  '-1',
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
] as const satisfies GradeEnum[];

export type OrgTypeEnum = components['schemas']['Org']['type'];
export const OrgTypeEnumValues = [
  'school',
  'district',
  'state',
  'local',
  'national',
  'department',
] as const satisfies OrgTypeEnum[];
